import { NistOutcome, NistFunction } from '../types/assessment'

export const NIST_FUNCTIONS: {
  id: NistFunction
  title: string
  description: string
}[] = [
  {
    id: 'Govern',
    title: 'Govern',
    description: 'Cultivate and implement a culture of risk management.',
  },
  {
    id: 'Map',
    title: 'Map',
    description: 'Context is recognized and risks are identified.',
  },
  {
    id: 'Measure',
    title: 'Measure',
    description: 'Identified risks are assessed, analyzed, and tracked.',
  },
  {
    id: 'Manage',
    title: 'Manage',
    description: 'Risks are prioritized and acted upon.',
  },
]

export const NIST_OUTCOMES: NistOutcome[] = [
  // GOVERN
  {
    id: 'GOVERN-1',
    function: 'Govern',
    title: 'Policies & Procedures',
    description:
      'Legal and regulatory requirements involving AI are understood and managed. Policies and procedures are in place.',
    subcategories: ['GOVERN 1.1', 'GOVERN 1.2'],
  },
  {
    id: 'GOVERN-2',
    function: 'Govern',
    title: 'Accountability',
    description:
      'Accountability structures are in place so that the appropriate teams and individuals are empowered, responsible, and trained.',
    subcategories: ['GOVERN 2.1', 'GOVERN 2.2', 'GOVERN 2.3'],
  },
  {
    id: 'GOVERN-3',
    function: 'Govern',
    title: 'Workforce Diversity',
    description:
      'Workforce diversity, equity, inclusion, and accessibility processes are prioritized.',
    subcategories: ['GOVERN 3.1', 'GOVERN 3.2'],
  },
  {
    id: 'GOVERN-4',
    function: 'Govern',
    title: 'Organizational Risk Culture',
    description:
      'Organizational teams are committed to a culture that considers and manages AI risks.',
    subcategories: ['GOVERN 4.1', 'GOVERN 4.2', 'GOVERN 4.3'],
  },
  {
    id: 'GOVERN-5',
    function: 'Govern',
    title: 'Engagement',
    description:
      'Processes are in place for robust engagement with relevant AI actors.',
    subcategories: ['GOVERN 5.1', 'GOVERN 5.2'],
  },

  // MAP
  {
    id: 'MAP-1',
    function: 'Map',
    title: 'Context Established',
    description: 'Context is established and understood.',
    subcategories: ['MAP 1.1', 'MAP 1.2', 'MAP 1.3'],
  },
  {
    id: 'MAP-2',
    function: 'Map',
    title: 'Categorization',
    description: 'AI system categorization is performed.',
    subcategories: ['MAP 2.1', 'MAP 2.2'],
  },
  {
    id: 'MAP-3',
    function: 'Map',
    title: 'Capabilities & Limitations',
    description:
      'AI capabilities, targeted usage, goals, and expected benefits and costs are understood.',
    subcategories: ['MAP 3.1', 'MAP 3.2', 'MAP 3.3', 'MAP 3.4'],
  },
  {
    id: 'MAP-4',
    function: 'Map',
    title: 'Risks & Impacts',
    description:
      'Risks and benefits are mapped for all components of the AI system.',
    subcategories: ['MAP 4.1', 'MAP 4.2'],
  },
  {
    id: 'MAP-5',
    function: 'Map',
    title: 'Impacts to Individuals',
    description:
      'Impacts to individuals, groups, communities, organizations, and society are characterized.',
    subcategories: ['MAP 5.1', 'MAP 5.2'],
  },

  // MEASURE
  {
    id: 'MEASURE-1',
    function: 'Measure',
    title: 'Methods & Metrics',
    description: 'Appropriate methods and metrics are identified and applied.',
    subcategories: ['MEASURE 1.1', 'MEASURE 1.2', 'MEASURE 1.3'],
  },
  {
    id: 'MEASURE-2',
    function: 'Measure',
    title: 'Evaluation',
    description: 'AI systems are evaluated for trustworthy characteristics.',
    subcategories: ['MEASURE 2.1', 'MEASURE 2.2', 'MEASURE 2.3'],
  },
  {
    id: 'MEASURE-3',
    function: 'Measure',
    title: 'Feedback Mechanisms',
    description:
      'Mechanisms for tracking identified AI risks over time are in place.',
    subcategories: ['MEASURE 3.1', 'MEASURE 3.2'],
  },
  {
    id: 'MEASURE-4',
    function: 'Measure',
    title: 'Feedback Evaluation',
    description:
      'Feedback on efficacy of measurement is gathered and assessed.',
    subcategories: ['MEASURE 4.1', 'MEASURE 4.2'],
  },

  // MANAGE
  {
    id: 'MANAGE-1',
    function: 'Manage',
    title: 'Risk Prioritization',
    description: 'AI risks are prioritized and acted upon.',
    subcategories: ['MANAGE 1.1', 'MANAGE 1.2', 'MANAGE 1.3'],
  },
  {
    id: 'MANAGE-2',
    function: 'Manage',
    title: 'Strategies',
    description:
      'Strategies to maximize benefits and minimize negative impacts are planned and implemented.',
    subcategories: ['MANAGE 2.1', 'MANAGE 2.2', 'MANAGE 2.3'],
  },
  {
    id: 'MANAGE-3',
    function: 'Manage',
    title: 'Response',
    description: 'AI risks and benefits are managed on a regular basis.',
    subcategories: ['MANAGE 3.1', 'MANAGE 3.2'],
  },
  {
    id: 'MANAGE-4',
    function: 'Manage',
    title: 'Documentation',
    description:
      'Risk management policies, processes, procedures, and practices are documented.',
    subcategories: ['MANAGE 4.1', 'MANAGE 4.2', 'MANAGE 4.3'],
  },
]

export const NIST_EVIDENCE_TYPES = [
  'Governance Policy',
  'Risk Management Framework',
  'System Documentation',
  'Stakeholder Analysis',
  'Impact Assessment',
  'Testing Report',
  'Performance Metrics',
  'Monitoring Log',
  'Incident Response Plan',
  'Change Management Record',
  'Other',
]
